import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { api, BACKEND_URL } from "../lib/api";

export default function FeaturedCoupleSection() {
  const [featured, setFeatured] = useState(null);
  useEffect(() => {
    api.get("/featured-couple").then((r) => setFeatured(r.data.featured)).catch(() => {});
  }, []);
  if (!featured) return null;
  const w = featured.wedding;
  const photo = featured.photo_url || featured.gallery?.find((m) => m.content_type?.startsWith("image/"))?.storage_path;
  const photoSrc = photo
    ? (photo.startsWith("http") ? photo : `${BACKEND_URL}/api/files/${photo}`)
    : "https://images.pexels.com/photos/33403878/pexels-photo-33403878.jpeg?w=1200";

  return (
    <section className="bg-[var(--bg-warm)] section-pad">
      <div className="container-wide px-6 md:px-12 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="luxe-image relative">
          <img src={photoSrc} alt={w.couple_names} className="w-full h-[520px] object-cover" />
          <div className="absolute top-6 left-6 glass-light rounded-full px-4 py-2 flex items-center gap-2">
            <Star className="w-4 h-4 text-[var(--gold)]" />
            <span className="text-[11px] uppercase tracking-[0.18em]">Couple of the Week</span>
          </div>
        </motion.div>
        <motion.div initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <p className="text-[11px] uppercase tracking-[0.22em] text-[var(--gold)] mb-3">Featured</p>
          <h2 className="font-script text-[var(--gold)] text-5xl md:text-7xl mb-2">{w.couple_names}</h2>
          {w.wedding_date && <p className="text-sm uppercase tracking-[0.22em] text-[var(--muted)] mb-6">{new Date(w.wedding_date).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}{w.city ? ` · ${w.city}` : ""}</p>}
          <p className="text-[var(--muted)] mb-8 max-w-md leading-relaxed">{featured.story || w.story || "A love story being written, one day at a time. Built on LockedInForever."}</p>
          <Link to={`/site/${w.slug}`} className="btn-gold">Visit their wedding site <ArrowRight className="w-4 h-4" /></Link>
        </motion.div>
      </div>
    </section>
  );
}
